export function loadInviteeList() {
  return {
    type: 'LOAD_INVITEE_LIST',
  };
}

export function loadInviteeListCompletion(data = {}, error = null) {
  return {
    type: 'LOAD_INVITEE_LIST_COMPLETION',
    list: data.listData || [],
    error,
  };
}

export function loadAwardList(query) {
  return {
    type: 'LOAD_AWARD_LIST',
    query,
    willReload: !!query,
  };
}

export function loadAwardListCompletion(error, list) {
  return {
    type: 'LOAD_AWARD_LIST_COMPLETION',
    error,
    list,
  };
}

export function getSharePost() {
  return {
    type: 'GET_SHARE_POST',
  };
}

export function getSharePostCompletion(error, data) {
  return {
    type: 'GET_SHARE_POST_COMPLETION',
    error,
    data,
  };
}

export function loadMemberMineBannerList() {
  return {
    type: 'LOAD_MEMBER_MINE_BANNER_LIST',
  };
}

export function loadMemberMineBannerListCompletion(error, data) {
  return {
    type: 'LOAD_MEMBER_MINE_BANNER_LIST_COMPLETION',
    error,
    list: (data && data.fxbanner) || [],
  };
}
